<template>
  <div>
    <input ref="fileInput" type="file" style="display: none;" @change="selectFile($event)">
    <div
      class="file-input__wrapper js-file-input-wrapper spacer-bottom-st"
    >
      <div class="file-input__box file-input__box-title">
        <p class="mr-2">
          {{ alias }}
        </p>
      </div>
      <div class="file-input__box">
        <button v-if="canAddFile" class="btn btn-primary" @click="addFile()">
          Adicionar Arquivo
        </button>
        <p v-if="fileName" class="ellipsis">
          {{ fileName }}
        </p>
        <i v-if="fileName && !previewUrl" class="fas fa-trash file-input__top-icon" @click="clearImage"></i>
      </div>
      <template v-if="cropping && !previewUrl">
        <div class="file-input__cropper-wrapper">
          <div class="vue-cropper-wrapper">
            <vue-cropper
              ref="cropper"
              alt="Imagem enviada"
              drag-mode="crop"
              :guides="true"
              :src="fileSrc"
              :min-container-width="50"
              :min-container-height="50"
              :auto-crop="false"
              :auto-crop-area="1"
              :restore="false"
              :center="false"
              :highlight="false"
              :crop-box-movable="true"
              :toggle-drag-mode-on-dblclick="false"
              :zoom-on-touch="false"
              :zoom-on-wheel="false"
              :img-style="{ height: '400px', maxWidth: '100%' }"
            />
          </div>
          <div v-if="cropping" class="file-input__box-tools">
            <div v-if="editing" class="vue-cropper__tools">
              <i class="fas fa-search-plus vue-cropper__tools--icon" @click="zoomIn"></i>
              <i class="fas fa-search-minus vue-cropper__tools--icon" @click="zoomOut"></i>
              <i class="fas fa-undo vue-cropper__tools--icon" @click="rotateLeft"></i>
              <i class="fas fa-redo vue-cropper__tools--icon" @click="rotateRight"></i>
              <i class="fas fa-trash vue-cropper__tools--icon" @click="clearImage"></i>
              <i class="fas fa-check vue-cropper__tools--icon" @click="cropImage"></i>
            </div>
            <div v-else class="vue-cropper__tools-edit">
              <span class="vue-cropper__tools-text" @click="enableEditing">
                <i class="fas fa-crop vue-cropper__tools--icon"></i>
                Editar
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="previewUrl">
        <div class="file-input__box">
          <img :src="previewUrl" class="file-input__image-preview">
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.vue-cropper-wrapper {
  position: relative;
  width: 100%;
}
.vue-cropper__tools {
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 300px;
}
.vue-cropper__tools--icon {
  cursor: pointer;
  color: white;
  margin: 0.5rem;
}
.vue-cropper__tools-edit {
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 100px;
  z-index: 4;
}
.vue-cropper__tools-text {
  margin: 0.5rem;
  cursor: pointer;
  color: white;
  z-index: 4;
}
.file-input__box-title {
  border-bottom: 2px solid #EBEBEB;
}
.file-input__box-tools {
  background: #3B4749;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 8px 24px 24px;
  position: relative;
  width: 100%;
}
.file-input__box {
  align-content: center;
  color: #1F2D30;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  justify-content: space-between;
  line-height: 1.5rem;
  padding: 16px;
  align-items: center;
}
.file-input__wrapper {
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(31,45,48,0.16);
  position: relative;
}
.spacer-st, .spacer-bottom-st {
  margin-bottom: 24px;
}
.ellipsis {
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-input__image-preview {
  display: block;
  margin: auto;
  max-height: 600px;
  max-width: 100%;
}
.file-input__top-icon {
  cursor: pointer;
  margin-left: 8px;
}
.loading-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 3;
}
.editing-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;
}
.file-input__cropper-wrapper {
  position: relative;
}
</style>

<script>
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
import 'assets/stylesheets/components/_cropper.scss';

export default {
  components: {
    VueCropper,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    alias: {
      type: String,
      required: true,
    },
    previewUrl: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingImage: false,
      editing: false,
      fileSrc: null,
      cropping: false,
      fileName: '',
      translatedStatus: {
        pendent: 'pendent',
        sent: 'doing',
        approved: 'done',
        reproved: 'pendent',
      },
      translatedText: {
        pendent: 'Pendente',
        sent: 'Em Análise',
        approved: 'Aprovado',
        reproved: 'Pendente',
      },
    };
  },
  computed: {
    canAddFile() {
      return !this.value && !this.cropping && !this.fileName && !this.previewUrl;
    },
  },
  created() {
    this.$emit('input', null);
    this.fileSrc = null;
  },
  methods: {
    enableEditing() {
      this.editing = true;
      this.$refs.cropper.initCrop();
    },
    addFile() {
      this.$refs.fileInput.click();
    },
    // eslint-disable-next-line consistent-return
    selectFile($event) {
      const file = $event.target.files[0];
      const acceptedFiles = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
      this.fileName = '';
      if (file) {
        if (acceptedFiles.indexOf(file.type) < 0) {
          return this.$toast.error('Arquivo inválido, apenas imagens e PDFs são aceitos');
        }
        const reader = new FileReader();
        this.fileName = file.name;
        reader.onload = (event) => {
          if (file.type.includes('image/')) {
            this.cropping = true;
            this.fileSrc = event.target.result;
          }
          this.$emit('input', event.target.result);
          this.editing = false;
        };
        reader.readAsDataURL(file);
      }
    },
    cropImage() {
      this.loadingImage = true;

      setTimeout(() => {
        const croppedCanvas = this.$refs.cropper.getCroppedCanvas();
        if (croppedCanvas) {
          this.fileSrc = croppedCanvas.toDataURL();
          this.$refs.cropper.replace(croppedCanvas.toDataURL());
          this.$emit('input', this.fileSrc);
        }

        this.loadingImage = false;
        this.editing = false;
      });
    },
    rotateRight() {
      this.$refs.cropper.rotate(10);
    },
    rotateLeft() {
      this.$refs.cropper.rotate(-10);
    },
    zoomIn() {
      this.$refs.cropper.relativeZoom(0.1);
    },
    zoomOut() {
      this.$refs.cropper.relativeZoom(-0.1);
    },
    clearImage() {
      this.$refs.fileInput.value = null;
      this.fileSrc = null;
      this.$emit('input', null);
      this.cropping = false;
      this.fileName = '';
    },
  },
};
</script>
